import {$authHost, $host} from ".";

export const indexPlugins = async () => {
    const {data} = await $authHost.get('api/v1/plugins.php', {});
    return data;
};

export const updatePlugin = async (plugin_id) => {
    const {data} = await $authHost.post('api/v1/plugins.php/' + plugin_id, {},{withCredentials: true});
    return data;
};

export const updatePluginSetting = async (plugin) => {
    const {data} = await $authHost.post('api/v1/updatePluginSetting.php', plugin,{withCredentials: true});
    return data;
};

export const createPlugin = async (plugin) => {
    const {data} = await $authHost.post('api/v1/createPlugin.php', plugin,{withCredentials: true});
    return data;
};

export const statusPlugin = async (plugin_id, status) => {
    const {data} = await $authHost.post('api/v1/statusPlugin.php', {plugin_id, status},{withCredentials: true});
    return data;
};

export const getPluginDetails = async (plugin_id) => {
    const {data} = await $authHost.post('api/v1/getPluginDetails.php', {plugin_id},{withCredentials: true});
    return data;
};

export const getPluginEdit = async (plugin_id, addition_id, filename) => {
    const {data} = await $authHost.post('api/v1/getPluginEdit.php', {plugin_id, addition_id, filename},{withCredentials: true});
    return data;
};

export const updatePluginFile = async (plugin_id, addition_id, filename, code) => {
    const {data} = await $authHost.post('api/v1/updatePluginFile.php', {plugin_id, addition_id, filename, code},{withCredentials: true});
    return data;
};

export const visibilityPlugin = async (plugin_id, visible) => {
    const {data} = await $authHost.post(
        'api/v1/visibilityPlugin.php',
        {plugin_id, visible},
        {withCredentials: true}
    );
    return data;
};
